/** Filter sentinel for "Not related to a meeting": the storage maps it to `noFabricator=true`. */
export const FYI_NO_FABRICATOR = 'NONE';

/** 30 MB per attachment, enforced by the API (422) and checked client-side by the create form. */
export const FYI_MAX_FILE_BYTES = 31457280;

export const FYI_DATE_FORMAT = 'd MMMM yyyy';
